export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./Clientes.html?vue&type=template&id=fe6db9e0&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/clientes/Clientes.html?vue&type=template&id=fe6db9e0&
// module id = 475
// module chunks = 1